import { render, staticRenderFns } from "./RichTextField.vue?vue&type=template&id=9af931c6&scoped=true"
import script from "./RichTextField.vue?vue&type=script&lang=js"
export * from "./RichTextField.vue?vue&type=script&lang=js"
import style0 from "./RichTextField.vue?vue&type=style&index=0&id=9af931c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af931c6",
  null
  
)

export default component.exports